module.exports = __webpack_public_path__ + "img/r5_chiyanfenghuang.7d1e3e2c.jpg";